import styles from "Pages/Run/Run.module.css";
import {
    IPendingFields,
    isWaitingOnPredecessor,
    predecessorSummary,
} from "Pages/Run/pendingJob";

/**
 * The Status cell for a job that has not started. Its whole job is to make the two not-started
 * states unmistakable at a glance (see Pages/Run/pendingJob.ts for why they were not).
 *
 * The predecessor's id is a LINK to its own run details when it has one, so the question Daniel
 * answered with three SQL queries on 2026-08-28 — "is the thing it is waiting on healthy?" — is
 * one click. job.message_id is only written when a shuttle picks the predecessor up, so a
 * predecessor that is itself still queued renders as plain text; there is no page to open yet.
 */
export default function PendingStatusCell({
    header,
}: {
    readonly header: IPendingFields;
}) {
    if (!isWaitingOnPredecessor(header)) {
        return (
            <span className={styles.pendingStatus}>
                Pending &mdash; not started
            </span>
        );
    }

    const jobLabel = `#${header.waiting_on_job_id}`;

    return (
        <span className={styles.waitingStatus}>
            <span className={styles.waitingHeadline}>
                Waiting on{" "}
                {header.waiting_on_message_id ? (
                    <a
                        href={`/run_details/${header.waiting_on_message_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {jobLabel}
                    </a>
                ) : (
                    jobLabel
                )}
            </span>
            <span className={styles.waitingPredecessor}>
                {predecessorSummary(header)}
            </span>
        </span>
    );
}
